import React, {Component} from 'react';
import Flickity from './Flickity';
import IconArrowCarousel from './IconArrowCarousel';
import breakpoints from '../config/breakpoints';
import ImageGalleryModal from './ImageGalleryModal';

const BACKGROUND_COLOR = {hex: '#000'};
const COLOR = {hex: '#fff'};
const SLIDE_OPTIONS = {
	cellAlign: 'left',
	contain: true,
	wrapAround: false,
	pageDots: false,
	prevNextButtons: false,
	selectedAttraction: 0.1,
	friction: 0.8,
	imagesLoaded: true,
};

export default class ProductMediaGallery extends Component {
	constructor() {
		super();

		this.state = {
			activeImageIndex: 0,
			isModalOpen: false,
		};
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (this.state.activeImageIndex !== prevState.activeImageIndex) {
			this.modalSlider && this.modalSlider.select(this.state.activeImageIndex);
		}
	}

	closeGalleryModal = () => {
		this.setState({isModalOpen: false});
	}

	onClickPrevious = () => {
		this.slider && this.slider.previous();
	}

	onClickNext = () => {
		// Disable going to the last slide on desktop
		if (
			global.innerWidth >= breakpoints.md &&
			this.state.activeImageIndex >= this.props.images.length - 2
		) return;

		this.slider && this.slider.next();
	}

	setAssetIndex = activeImageIndex => {
		this.setState({activeImageIndex});
	}

	onSetSliderRef = slider => {
		this.slider = slider;

		this.slider.on('change', () => {
			this.setState({
				activeImageIndex: this.slider.selectedIndex,
			});
		});

		this.slider.on('staticClick', ( event, pointer, cellElement, cellIndex ) => {
			this.setState({
				activeImageIndex: cellIndex,
				isModalOpen: true,
			});
		});
	}

	render() {
		const {
			title,
			backgroundColor = BACKGROUND_COLOR,
			textColor = COLOR,
			images,
		} = this.props;

		const {
			activeImageIndex,
			isModalOpen,
		} = this.state;

		const header = (
			<div className="media media--horizontal media--reverse gutter--small align--middle">
				<div className="media__fluid">
					<h2 className="uppercase fw--600">
						{title}
					</h2>
				</div>
				<div className="media__fixed">
					<ul className="list list--horizontal list--forward gutter--small tr align--middle">
						<li className="list__item">
							<button
								title="previous"
								onClick={this.onClickPrevious}
								className="db"
								name="previous">
								<IconArrowCarousel
									className="db flip"
								/>
							</button>
						</li>
						<li className="list__item show--md">
							<p className="fw--600 sans--small ">
								{activeImageIndex + 1} of {images.length}
							</p>
						</li>
						<li className="list__item">
							<button
								title="next"
								onClick={this.onClickNext}
								className="db"
								name="next">
								<IconArrowCarousel
									className="db"
								/>
							</button>
						</li>
					</ul>
				</div>
			</div>
		);

		const mediaCarousel = (
			<div className="media-gallery">
				<Flickity
					sliderRef={this.onSetSliderRef}
					options={SLIDE_OPTIONS}>
					{images.map((image, index) => (
						<div
							className="media-gallery__col"
							key={image._key}>
							<picture
								className="full-width cursor--pointer product__hero-zoom"
							>
								<img
									className="full-width"
									alt={image.alt}
									src={`${image.url}?w=800&auto=format`}
								/>
							</picture>
						</div>
					))}
				</Flickity>
			</div>
		);

		const modal = (
			<ImageGalleryModal
				active={isModalOpen}
				assets={this.props.images ? this.props.images : []}
				initialIndex={activeImageIndex}
				onClose={this.closeGalleryModal}
				sliderRef={slider => this.modalSlider = slider}
				onNext={this.onClickNext}
				onPrevious={this.onClickPrevious}
				onChange={this.setAssetIndex}
				preserveImageAspectRatio
			/>
		);

		return (
			<React.Fragment>
			<div
				style={{
					backgroundColor: backgroundColor.hex,
					color: textColor.hex,
				}}
				className="pt6 pb6 of--hidden">
				<div className="pt6--md pb6--md">
					<div className="grid-container contained">
						<div className="mb3 mb4--md">
							{header}
						</div>
						<hr className="invert mb4 mb6--md" />
						{mediaCarousel}
					</div>
				</div>
			</div>
			{modal}
			</React.Fragment>
		);
	}
}
